import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { VariantsOverviewComponent } from './variants-overview/variants-overview.component';
import { CartridgesBackofficeFeatureVariantsOverviewRoutingModule } from './cartridges-backoffice-feature-variants-overview-routing.module';
import { MarkantElementsModule } from '@markant/elements-angular';
import { TranslocoModule } from '@jsverse/transloco';
import { SharedDashboardModule } from '@markant-platform/shared/dashboard';
import { UiPageHeaderComponent } from '@markant-platform/shared/ui-components';

@NgModule({
  imports: [
    CommonModule,
    CartridgesBackofficeFeatureVariantsOverviewRoutingModule,
    MarkantElementsModule,
    TranslocoModule,
    SharedDashboardModule,
    UiPageHeaderComponent,
  ],
  declarations: [VariantsOverviewComponent],
})
export class CartridgesBackofficeFeatureVariantsOverviewModule {}
